import React from "react";
import "./ProgDisplay.scss";

const ProgDisplay = ({ children, text, className, hidden }) => {
  return (
    <div
      className={`row-start prog-display ${className} ${hidden && "hidden"}`}
    >
      {children}
      <p>{text}</p>
    </div>
  );
};

export default ProgDisplay;
